var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 110.059 110.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Union_38",
    x: 0,
    y: 0,
    width: 110.059,
    height: 110.373,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21709",
    "data-name": "Group 21709",
    transform: "translate(4703.759 -13691.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21707",
    "data-name": "Group 21707",
    transform: "translate(258 164.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20045",
    "data-name": "Group 20045",
    transform: "translate(-6242.729 12590.873)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1280.97, 936.31)",
    filter: "url(#Union_38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_38-2",
    "data-name": "Union 38",
    d: "M0,46.344A46.031,46.031,0,0,1,45.446.318L45.4.272,79.563,0S91.655.227,91.655,13.39c0,8.418.12,20.824.207,28.676q.195,2.114.2,4.278A46.029,46.029,0,1,1,0,46.344Z",
    transform: "translate(9 6)",
    fill: "#f7f8fa"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_396",
    "data-name": "Line 396",
    x2: 17.048,
    transform: "translate(1327.04 983.541)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_397",
    "data-name": "Line 397",
    x2: 17.048,
    transform: "translate(1327.04 990.36)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21279",
    "data-name": "Group 21279",
    transform: "translate(-4920.73 13564.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17405",
    "data-name": "Path 17405",
    d: "M3.574,30.373Z",
    transform: "translate(-3.062 -2.886)",
    fill: "#334350"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21708",
    "data-name": "Group 21708",
    transform: "translate(-4664.842 13724.311)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6113",
    "data-name": "Rectangle 6113",
    width: 40,
    height: 40,
    transform: "translate(-4.158 -0.31)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17699",
    "data-name": "Path 17699",
    d: "M2,28.529a.809.809,0,0,1-.572-1.382L23.3,5.27a.81.81,0,1,1,1.146,1.146L2.569,28.293A.814.814,0,0,1,2,28.529Z",
    transform: "translate(2.908 2.909)",
    fill: "#334350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17700",
    "data-name": "Path 17700",
    d: "M23.873,28.529a.814.814,0,0,1-.574-.237L1.423,6.415A.81.81,0,0,1,2.569,5.27L24.445,27.147a.809.809,0,0,1-.572,1.382Z",
    transform: "translate(2.908 2.909)",
    fill: "#3f4d5d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1eeb2df6176393fcd151e2bbe5a35eca.svg";
export { ForwardRef as ReactComponent };